import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=49c9c506&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=49c9c506&scoped=true&lang=css&"
import style1 from "./Main.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Main.vue?vue&type=style&index=2&id=49c9c506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c9c506",
  null
  
)

export default component.exports